import { Network, NetworkId, Networks } from 'modules/network';

const DefaultNetworkId: NetworkId = 'pz';

type TGetNetworkOptions = {
  networkId: NetworkId;
};

function getNetwork({ networkId }: TGetNetworkOptions): Network {
  return Networks[networkId];
}

export { DefaultNetworkId, getNetwork };
